import {
  get,
  keyBy,
} from 'lodash';
import {
  ELSAdobeAnalyticService,
  ELSCommonUIConstants,
  ELSLoggingService
} from '@els/els-ui-common-react';
import axios, { AxiosResponse } from 'axios';
import {
  fetchAssessmentSubmissions as fetchAssessmentSubmissionsService,
  fetchOsmosisToken,
  fetchUsers as fetchUsersService,
  fetchVitalSource
} from '../../apis/sherpath-course-management-service/sherpath-course-management-service.utilities';
import {
  fetchAppLinkData as fetchAppLinkDataService,
  fetchHashLink,
  getExternalAppRedirectUrl,
  getLinkNavigation,
} from '../../apis/eols-app-link/eols-app-link.utilities';
import {
  fetchCourseSection as fetchCoursePlanningCourseSectionService,
  updateCourseSection as updateCourseSectionService,
} from '../../apis/eols-course-management-service/eols-course-management-service.utilities';
import {
  fetchCourseSection as fetchCourseSectionService,
  fetchUserCourseSections,
} from '../../apis/eols-course-crud/eols-course-crud.utilities';
import { reduxStateDomains } from '../redux.constants';
import {
  UserDto,
} from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { AppLinkData } from '../../apis/eols-app-link/eols-app-link.dtos';
import { LiteCourseSectionDto } from '../../apis/eols-course-management-service/eols-course-management-service.dtos';
import {
  fetchCrosswalkUser as fetchCrosswalkUserService,
  fetchUser as fetchUserService
} from '../../apis/eols-user-management-service/eols-user-management-service.utilities';
import {
  fetchGroupedFeatureFlags,
  fetchGroupFeatureFlag,
  postGroupFeatureFlag
} from '../../apis/eols-features-api/eols-features-api.utilities';
import {
  deleteUserHistoryByUserId,
  fetchUserHistoryByCourseByStateKey as fetchUserHistoryByCourseByStateKeyService,
  postUserHistory as postUserHistoryService,
} from '../../apis/eols-user-crud/eols-user-crud.utilities';
import { CourseSectionDto } from '../../apis/eols-course-crud/eols-course-crud.dtos';
import {
  CoursewareUserHistoryStateKey,
  EolsUserHistoryDto,
  EolsUserHistoryResponseDto,
} from '../../apis/eols-user-crud/eols-user-crud.dtos';
import { studySelectors } from './studentStudy.selectors';
import {
  RecTaxonomyNodeDto
} from '../../apis/rec-gateway/rec-gateway.dtos';
import {
  fetchPrimaryTaxonomy,
  fetchTaxonomy as fetchTaxonomyService
} from '../../apis/eols-taxonomy/eols-taxonomy.utilities';
import {
  AdobeAnalyticsActionProps,
  StudentStudyStore,
  NavigateToApp
} from './studentStudy.models';
import {
  AssessmentDto,
  AssessmentSubmissionDto,
  AssignmentDto,
} from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import {
  fetchAssessmentByAssignmentIdAndUserId as fetchAssessmentByAssignmentIdAndUserIdService,
  fetchAssessmentById,
  fetchAssessmentsByAssignmentIdAndUserId,
  fetchAssignment,
  fetchAssignmentResults,
  fetchAssignments as fetchAssignmentsService,
  fetchEolsAssessmentSubmissions,
  postAssessment,
  postSubmission,
  putAssignment as putAssignmentService,
} from '../../apis/eols-assessment-service/eols-assessment-service.utilities';
import {
  SystemType
} from '../../apis/eols-user-management-service/eols-user-management-service.dtos';
import {
  fetchCaseStudy,
  fetchLessonTopics,
  fetchResourceInfo
} from '../../apis/ocs-api-service/ocs-api-service.utilities';
import {
  addCookies,
  removeCookies
} from '../../pages/app-link-redirect/app-link-redirect.utilities';
import {
  AppLinkOutConfig,
  AppLinkOutResponse
} from '../../apis/eols-app-link/eols-app-link.models';
import { fetchUserEngagementReport as fetchUserEngagementReportService } from '../../apis/eols-user-engagement/eols-user-engagement.utilities';
import { EolsUserEngagementDto } from '../../apis/eols-user-engagement/eols-user-engagement.dtos';
import { Messages } from '../../translations/message.models';
import {
  GroupActivityDto
} from '../../apis/ocs-api-service/ocs-api-service.dtos';
import {
  AnalyticsAction,
  AnalyticsActionProps,
} from '../../models/analytics.models';
import { Application } from '../../apis/eols-app-link/eols-app-link.constants';
import {
  getStudentPerformanceDetails,
  fetchStudentStudyAssessments,
  fetchNumberOfQuestions,
  fetchIsbns as fetchIsbnsService
} from '../../apis/eaq-app-facade-service/eaq-app-facade-service.utilities';
import {
  fetchDeepLinkData,
  postDeepLink
} from '../../apis/eols-lms-config-service/eols-lms-config-service.utilities';
import { DeepLinkPostDto } from '../../apis/eols-lms-config-service/eols-lms-config-service.dtos';
import { fetchAnalyticsContext } from '../../apis/learning-analytics-service/learning-analytics-service.utilities';
import { LearningAnalyticsRequestDto } from '../../apis/learning-analytics-service/learning-analytics-service.dtos';
import {
  getAssessmentSubmissionsMap,
  shouldGetNewOsmosisToken
} from '../redux.utilities';
import {
  getRandomABTestFlavor,
  getActiveABTestFlags,
} from '../../utilities/featureFlag.utilities';
import {
  FeatureFlagDto,
  FeatureFlagsGroupedDto
} from '../../apis/eols-features-api/eols-features-api.dtos';
import { stripNilProps } from '../../utilities/common.utilities';
import { scrubProps } from '../../utilities/analytics.utilities';
import { fetchOsmosisTranscript } from '../../apis/osmosis-service/osmosis-service.utilities';
import { EaqRecommenderQuestionsDto } from '../../apis/eaq-app-facade-service/eaq-app-facade-service.dtos';
import { TopicQuestionCountDto } from '../../pages/eaq-self-study-assessment-editor/eaq-self-study-assessment-editor.models';

const fileName = 'student-study.actions';

export interface UserParams {
  userId: string;
  courseId: string | null;
  roleId: string;
  isbns: string;
}

export const studentStudyActionType = {
  FETCH_STUDENT_STUDY_ASSESSMENTS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_STUDENT_STUDY_ASSESSMENTS`,
  FETCH_STUDENT_PERFORMANCE_DETAILS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_STUDENT_PERFORMANCE_DETAILS_SUCCESS`,
  DELETE_USER_HISTORY_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/DELETE_USER_HISTORY_SUCCESS`,
  FETCH_USER_HISTORY_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USER_HISTORY_SUCCESS`,
  FETCH_COURSE_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_COURSE_SUCCESS`,
  FETCH_GROUPED_FEATURE_FLAGS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_GROUPED_FEATURE_FLAGS_SUCCESS`,
  FETCH_FEATURE_ISBNS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_FEATURE_ISBNS`,
  FETCH_LINK_DATA_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_LINK_DATA_SUCCESS`,
  FETCH_USER_COURSE_OWNER_RECORDS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USER_COURSE_OWNER_RECORDS_SUCCESS`,
  FETCH_USER_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USER_SUCCESS`,
  FETCH_USERS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USERS_SUCCESS`,
  POST_COURSE_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/POST_COURSE_SUCCESS`,
  REQUEST_ERROR: `${reduxStateDomains.STUDENTSTUDY_STATE}/REQUEST_ERROR`,
  REQUEST_START: `${reduxStateDomains.STUDENTSTUDY_STATE}/REQUEST_START`,
  REQUEST_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/REQUEST_SUCCESS`,
  RESET_STORE: `${reduxStateDomains.STUDENTSTUDY_STATE}/RESET_STORE`,
  RESET_STATE_ON_LAUNCH: `${reduxStateDomains.STUDENTSTUDY_STATE}/RESET_STATE_ON_LAUNCH`,
  RESTORE_STATE: `${reduxStateDomains.STUDENTSTUDY_STATE}/RESTORE_STATE`,
  SET_IS_COURSE_OWNER_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_IS_COURSE_OWNER_SUCCESS`,
  SET_ISBNS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_ISBNS`,
  SET_MESSAGES: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_MESSAGES`,
  SET_USER: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_USER`,
  SET_REGISTERED_TOKEN: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_REGISTERED_TOKEN`,
  FETCH_CATALOG_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_CATALOG_SUCCESS`,
  FETCH_PRIMARY_TAXONOMY_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_PRIMARY_TAXONOMY_SUCCESS`,
  FETCH_ASSIGNMENT_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_ASSIGNMENT_SUCCESS`,
  DELETE_SYLLABUS_ITEMS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/DELETE_SYLLABUS_ITEMS_SUCCESS`,
  FETCH_ASSESSMENT_SUBMISSIONS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_ASSESSMENT_SUBMISSIONS_SUCCESS`,
  FETCH_ALL_ASSESSMENT_SUBMISSIONS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_ALL_ASSESSMENT_SUBMISSIONS_SUCCESS`,
  FETCH_ASSIGNMENTS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_ASSIGNMENTS_SUCCESS`,
  FETCH_SYLLABUS_ITEMS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_SYLLABUS_ITEMS_SUCCESS`,
  POST_SYLLABUS_ASSIGNMENT_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/POST_SYLLABUS_ASSIGNMENT_SUCCESS`,
  POST_SYLLABUS_ITEMS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/POST_SYLLABUS_ITEMS_SUCCESS`,
  PUT_SYLLABUS_ASSIGNMENT_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/PUT_SYLLABUS_ASSIGNMENT_SUCCESS`,
  PUT_SYLLABUS_ITEMS_BATCH_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/PUT_SYLLABUS_ITEMS_BATCH_SUCCESS`,
  PUT_ASSIGNMENTS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/PUT_ASSIGNMENTS_SUCCESS`,
  SET_CHECKED_SYLLABUS_ITEMS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_CHECKED_SYLLABUS_ITEMS`,
  SET_SYLLABUS_FOLDER_INFO: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_SYLLABUS_FOLDER_INFO`,
  SET_IS_BATCH_EDIT_MODE: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_IS_BATCH_EDIT_MODE`,
  SET_IS_DRAG_DROP_MODE: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_IS_DRAG_DROP_MODE`,
  UPDATE_COURSE_BUILDER_STATE: `${reduxStateDomains.STUDENTSTUDY_STATE}/UPDATE_COURSE_BUILDER_STATE`,
  FETCH_EOLS_USER_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_EOLS_USER_SUCCESS`,
  FETCH_CROSSWALK_USERS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_CROSSWALK_USERS_SUCCESS`,
  FETCH_EVOLVE_USER_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_EVOLVE_USER_SUCCESS`,
  POST_USER_HISTORY_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/POST_USER_HISTORY_SUCCESS`,
  SET_EBOOK_FILTER: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_EBOOK_FILTER`,
  HANDLE_EBOOK_FILTER_CHANGE: `${reduxStateDomains.STUDENTSTUDY_STATE}/HANDLE_EBOOK_FILTER_CHANGE`,
  HANDLE_PRODUCT_FILTER_CHANGE: `${reduxStateDomains.STUDENTSTUDY_STATE}/HANDLE_PRODUCT_FILTER_CHANGE`,
  HANDLE_RESOURCE_STATUS_FILTER_CHANGE: `${reduxStateDomains.STUDENTSTUDY_STATE}/HANDLE_RESOURCE_STATUS_FILTER_CHANGE`,
  HANDLE_RESOURCE_TYPE_FILTER_CHANGE: `${reduxStateDomains.STUDENTSTUDY_STATE}/HANDLE_RESOURCE_TYPE_FILTER_CHANGE`,
  HANDLE_RESOURCE_GRADING_FILTER_CHANGE: `${reduxStateDomains.STUDENTSTUDY_STATE}/HANDLE_RESOURCE_GRADING_FILTER_CHANGE`,
  SET_ASSESSMENT_START_TIME_MAP: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_ASSESSMENT_START_TIME_MAP`,
  SET_APP_LINK_COOKIES: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_APP_LINK_COOKIES`,
  UPDATE_COLLAPSED_FOLDER_IDS: `${reduxStateDomains.STUDENTSTUDY_STATE}/UPDATE_COLLAPSED_FOLDER_IDS`,
  FETCH_SKILL_STATIC_DATA: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_SKILL_STATIC_DATA`,
  FETCH_SKILL_SUBMISSION_RECORD: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_SKILL_SUBMISSION_RECORD`,
  SET_STORE_PROPS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_STORE_PROPS`,
  FETCH_COURSE_COPY_PREVIEW_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_COURSE_COPY_PREVIEW_SUCCESS`,
  SET_BATCH_EDIT_SELECTED_SYLLABUS_ITEMS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_BATCH_EDIT_SELECTED_SYLLABUS_ITEMS`,
  SET_BATCH_EDIT_UPDATED_SYLLABUS_ITEMS: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_BATCH_EDIT_UPDATED_SYLLABUS_ITEMS`,
  FETCH_USER_ENGAGEMENT_REPORT_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USER_ENGAGEMENT_REPORT_SUCCESS`,
  CLEAR_ALL_FILTERS: `${reduxStateDomains.STUDENTSTUDY_STATE}/CLEAR_ALL_FILTERS`,
  FETCH_MODULE_SEQUENCE_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_MODULE_SEQUENCE_SUCCESS`,
  POST_CREATE_ASSESSMENT_FROM_ASSIGNMENT_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/POST_CREATE_ASSESSMENT_FROM_ASSIGNMENT_SUCCESS`,
  FETCH_USER_RECENT_ASSESSMENT_BY_ASSIGNMENT_ID: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_USER_RECENT_ASSESSMENT_BY_ASSIGNMENT_ID`,
  FETCH_GROUP_ACTIVITY_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_GROUP_ACTIVITY_SUCCESS`,
  SET_ENABLE_DEEP_LINK: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_ENABLE_DEEP_LINK`,
  SET_HAS_RUN_AUTHESS_HEALTH_CHECK: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_HAS_RUN_AUTHESS_HEALTH_CHECK`,
  FETCH_OSMOSIS_TOKEN_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_OSMOSIS_TOKEN_SUCCESS`,
  FETCH_AB_TEST_FLAVOR_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_AB_TEST_FLAVOR_SUCCESS`,
  FETCH_ALL_USER_COURSE_SECTIONS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_ALL_USER_COURSE_SECTIONS_SUCCESS`,
  SET_ECRID: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_ECRID`,
  FETCH_AVAILABLE_NUMBER_OF_QUESTIONS_SUCCESS: `${reduxStateDomains.STUDENTSTUDY_STATE}/FETCH_AVAILABLE_NUMBER_OF_QUESTIONS_SUCCESS`,
  SET_QUESTION_COUNT_BY_TOPIC_ACTION: `${reduxStateDomains.STUDENTSTUDY_STATE}/SET_QUESTION_COUNT_BY_TOPIC_ACTION`
};

const restoreState = (state) => ({ type: studentStudyActionType.RESTORE_STATE, payload: state });

export const resetState = () => (dispatch) => {
  dispatch({
    type: studentStudyActionType.RESET_STORE,
    payload: null
  });
};

export const resetStateOnLaunch = () => (dispatch) => {
  dispatch({
    type: studentStudyActionType.RESET_STATE_ON_LAUNCH,
    payload: null
  });
};

const trackAction = (props: AnalyticsActionProps) => (dispatch, getState) => {
  const defaultActionProps = studySelectors.getDefaultActionProps(getState());
  const actionProps = scrubProps(props.props);
  const _props = {
    ...defaultActionProps,
    ...actionProps
  };
  ELSLoggingService.info(fileName, `New Relic PageAction: ${props.action}, ${JSON.stringify(_props)}`);
  if (!window.newrelic) {
    return;
  }
  window.newrelic.addPageAction(props.action, _props);
};

const trackAdobeAction = (props: AdobeAnalyticsActionProps) => (dispatch, getState) => {
  const defaultPageData = studySelectors.getDefaultAdobeAnalyticsPageData(getState());
  const educationProps = stripNilProps(props.pageData.education);
  const pageData = {
    ...defaultPageData,
    education: {
      ...defaultPageData.education,
      ...educationProps
    }
  };
  ELSAdobeAnalyticService.trackEvent(props.action, pageData);
};

const handleRequestError = (dispatch, getState) => (
  error: Error,
  action: string,
  isTrackRequestCount = true
) => {
  const url = get(error, 'config.url', '');
  const method = get(error, 'config.method', '');
  const status = get(error, 'response.status', '');
  if (status === 400) {
    // Likely 400 error here due to overloaded headers
    removeCookies();
  }

  trackAction({
    action: AnalyticsAction.API_ERROR,
    props: {
      status,
      action,
      url,
      method
    }
  })(dispatch, getState);

  dispatch({
    type: studentStudyActionType.REQUEST_ERROR,
    payload: {
      error,
      isTrackRequestCount
    },
  });
  return Promise.reject(error);
};

const fetchCourseSection = (
  courseSectionId: string,
  useCache = false
) => (dispatch, getState): Promise<CourseSectionDto> => {
  if (!courseSectionId) {
    return Promise.resolve(null);
  }
  if (useCache) {
    const courseSection = studySelectors.getCourse(getState());
    if (courseSection) {
      return Promise.resolve(courseSection);
    }
  }
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return fetchCourseSectionService(courseSectionId)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_COURSE_SUCCESS,
        payload: response,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchCourseSection'));
};

const fetchIsbnsAction = (courseSectionId: string, userId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchIsbnsService(courseSectionId, userId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchIsbnsAction'));
};

const fetchAssessmentsByAssignmentIdAndUserIdAction = (
  userId: string,
  assignmentId: number
) => (dispatch, getState): Promise<AssessmentDto[]> => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssessmentsByAssignmentIdAndUserId(userId, assignmentId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssessmentsByAssignmentIdAndUserIdAction'));
};

const fetchRecentAssessmentOfAssignment = (
  userId: string,
  assignmentId: number
) => (dispatch, getState): Promise<AssessmentDto> => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssessmentByAssignmentIdAndUserIdService(userId, assignmentId)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_USER_RECENT_ASSESSMENT_BY_ASSIGNMENT_ID,
        payload: response,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchRecentAssessmentOfAssignment'));
};

const fetchUsers = (courseSectionIds: string[], roleId: string, userId: string, useCache = false) => (dispatch, getState): Promise<UserDto[]> => {

  if (useCache) {
    const users = studySelectors.getUsers(getState());
    if (users && users.length > 0) {
      return Promise.resolve(users);
    }
  }

  dispatch({ type: studentStudyActionType.REQUEST_START, });
  if (roleId === ELSCommonUIConstants.userType.Instructor) {
    return fetchUsersService(courseSectionIds)
      .then((users: UserDto[]) => {
        dispatch({
          type: studentStudyActionType.FETCH_USERS_SUCCESS,
          payload: users,
        });
        return users;
      })
      .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchUsers'));
  }

  return fetchUserService(userId)
    .then((user: UserDto) => {
      dispatch({
        type: studentStudyActionType.FETCH_USERS_SUCCESS,
        payload: [user],
      });
      return [user];
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchUsers'));

};

const getUpdatedPropsOnly = (existingCourse: LiteCourseSectionDto, propsToUpdate: Partial<LiteCourseSectionDto>): Partial<LiteCourseSectionDto> => {
  const ret = { ...propsToUpdate };
  Object.keys(propsToUpdate).forEach((key) => {
    if (existingCourse[key] === propsToUpdate[key]) {
      delete ret[key];
    }
  });
  return ret;
};

const updateCourseSection = (
  courseSectionId: string,
  updatedCourseInfo: Partial<LiteCourseSectionDto>,
) => (dispatch, getState): Promise<LiteCourseSectionDto> => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchCoursePlanningCourseSectionService(courseSectionId)
    .then(response => {
      const { etag } = response.headers as { etag: string };
      const _updatedCourseInfo = getUpdatedPropsOnly(response.data, updatedCourseInfo);
      return updateCourseSectionService(courseSectionId, _updatedCourseInfo, etag).then((data) => {
        dispatch({
          type: studentStudyActionType.POST_COURSE_SUCCESS,
          payload: data,
        });
        return data;
      });
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'updateCourseSection'));
};

// In the future we should consider retrieving this value from the token always
// For pilot and for development we need to separate these values from the token
// If we can reliably get pilot isbns into the token through evolve then this value should never be duplicated here
// Also note this is called Isbns plural because we can support mashup courses with multiple isbns
const setIsbns = isbn => dispatch => dispatch({ type: studentStudyActionType.SET_ISBNS, payload: isbn });

const setUser = ({ courseId, roleId, userId }: UserParams) => dispatch => dispatch(
  {
    type: studentStudyActionType.SET_USER, payload: { courseSectionId: courseId, roleId, userId }
  }
);

const setMessages = (messages: Messages) => dispatch => dispatch({ type: studentStudyActionType.SET_MESSAGES, payload: messages });

const fetchAppLinkData = (
  linkId: string
) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAppLinkDataService(linkId)
    .then((response: AppLinkData) => {
      dispatch({
        payload: response,
        type: studentStudyActionType.FETCH_LINK_DATA_SUCCESS,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAppLinkData'));
};

const getExternalAppRedirectUrlAction = (
  config: AppLinkOutConfig,
  token: string = null
) => (): Promise<AppLinkOutResponse> => {
  return getExternalAppRedirectUrl(config, token);
};

const setAppLinkCookies = (props: {
  token: string;
  linkId: string;
}) => (dispatch) => {
  dispatch({
    payload: props,
    type: studentStudyActionType.SET_APP_LINK_COOKIES
  });
};

const navigateToApp: NavigateToApp = (
  config: AppLinkOutConfig,
  isNewTab = false,
  token: string = null
) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return getExternalAppRedirectUrl(config, token)
    .then(({ redirectUrl, linkId }) => {

      trackAction({
        action: AnalyticsAction.APP_LINK_OUT,
        props: {
          linkType: config.action,
          srcApp: config.altSrcApp || Application.STUDENT_STUDY,
          targetApp: config.app
        }
      })(dispatch, getState);

      addCookies(linkId);

      if (isNewTab) {
        window.open(redirectUrl, '_blank');
      } else {
        window.location.href = redirectUrl;
      }
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'navigateToApp'));
};

const returnAppLink = (
  props: {
    linkId: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    returnPostBody: any;
  }
) => (dispatch, getState) => {
  const {
    linkId,
    returnPostBody
  } = props;
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return getLinkNavigation({ linkId, returnPostBody })
    .then(({ redirectUrl, linkId: responseLinkId }) => {
      addCookies(responseLinkId);
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      window.location.href = redirectUrl;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'returnAppLink'));
};

const fetchUserCourseOwnerRecords = (
  eolsUserHistoryRequest: {
    userId: number;
    courseSectionId: number;
    instanceId?: string;
  }
) => (dispatch, getState): Promise<EolsUserHistoryResponseDto[]> => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return fetchUserHistoryByCourseByStateKeyService({
    ...eolsUserHistoryRequest,
    stateKey: CoursewareUserHistoryStateKey.IS_COURSE_OWNER
  })
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_USER_COURSE_OWNER_RECORDS_SUCCESS,
        payload: response,
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        dispatch({
          type: studentStudyActionType.FETCH_USER_COURSE_OWNER_RECORDS_SUCCESS,
          payload: [],
        });
        return [];
      }
      return Promise.reject(error);
    })
    .catch((error) => {
      return handleRequestError(dispatch, getState)(error, 'fetchUserCourseOwnerRecords');
    });
};

const fetchUserHistoryByCourseByStateKey = (
  eolsUserHistoryRequest: {
    userId: number;
    stateKey: CoursewareUserHistoryStateKey;
    courseSectionId: number;
    instanceId?: string;
  }
) => (dispatch, getState): Promise<EolsUserHistoryResponseDto[]> => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return fetchUserHistoryByCourseByStateKeyService(eolsUserHistoryRequest)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_USER_HISTORY_SUCCESS,
        payload: { response, stateKey: eolsUserHistoryRequest.stateKey },
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        dispatch({
          type: studentStudyActionType.FETCH_USER_HISTORY_SUCCESS,
          payload: { response: [], stateKey: eolsUserHistoryRequest.stateKey },
        });
        return [];
      }
      return handleRequestError(dispatch, getState)(error, 'fetchUserHistoryByCourseByStateKey');
    });
};

const deleteUserHistoryWithUserId = (
  eolsUserHistoryRequest: {
    userId: number;
    instanceId?: string;
  }
) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return deleteUserHistoryByUserId(eolsUserHistoryRequest)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.DELETE_USER_HISTORY_SUCCESS,
        payload: { response },
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        dispatch({
          type: studentStudyActionType.DELETE_USER_HISTORY_SUCCESS,
          payload: { response: [] },
        });
        return [];
      }
      return handleRequestError(dispatch, getState)(error, 'deleteUserHistoryByUserId');
    });
};

const setIsCourseOwner = (
  eolsUserId: number,
  courseSectionId: string,
  isCourseOwner: string,
  eolsUserHistoryDto: Partial<EolsUserHistoryResponseDto> = {},
) => (dispatch, getState): Promise<EolsUserHistoryResponseDto> => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return postUserHistoryService({
    ...eolsUserHistoryDto,
    stateInfo: isCourseOwner,
    stateKey: CoursewareUserHistoryStateKey.IS_COURSE_OWNER,
    eolsUser: {
      id: eolsUserId
    },
    courseSectionId: parseInt(courseSectionId, 10),
  })
    .then((response) => {
      dispatch({
        type: studentStudyActionType.SET_IS_COURSE_OWNER_SUCCESS,
        payload: response,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'setIsCourseOwner'));
};

const postUserHistory = (
  eolsUserHistoryDto: EolsUserHistoryDto,
) => (dispatch, getState): Promise<EolsUserHistoryResponseDto> => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return postUserHistoryService(eolsUserHistoryDto)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.POST_USER_HISTORY_SUCCESS,
        payload: response,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'postUserHistory'));
};

const postGroupFeatureFlagAction = (eolsApp: string, featureName: string, group: string, featureValue: string): Promise<FeatureFlagDto> => {
  return postGroupFeatureFlag(eolsApp, featureName, group, featureValue).then(() => {
    return {
      createdAt: null,
      eolsApp,
      featureName,
      featureValue,
      group,
      updatedAt: null
    };
  });
};

const fetchABFlavor = (abTestFlag: FeatureFlagsGroupedDto) => (dispatch, getState) => {
  const abTestFlavors = studySelectors.getABTestFlavors(getState());
  const abTestFlavor = abTestFlavors.find((flag) => {
    return flag.featureName === abTestFlag.featureName;
  });
  if (abTestFlavor) {
    return Promise.resolve(abTestFlavor);
  }
  const courseSectionId = studySelectors.getCourseSectionId(getState());
  dispatch({ type: studentStudyActionType.REQUEST_START });
  const app = `SHER_EVOL_${abTestFlag.featureName}`;
  const key = abTestFlag.featureName;
  return fetchGroupFeatureFlag(app, key, courseSectionId)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        const newFlavor = getRandomABTestFlavor(abTestFlag);
        if (!newFlavor) {
          ELSLoggingService.error(fileName, `AB test config missing for flag: ${key}`);
          return Promise.resolve({
            createdAt: null,
            eolsApp: app,
            featureName: key,
            featureValue: null,
            group: courseSectionId,
            updatedAt: null
          });
        }
        return postGroupFeatureFlagAction(app, key, courseSectionId, newFlavor);
      }
      return Promise.reject(error);
    })
    .then((response) => {
      dispatch({ payload: response, type: studentStudyActionType.FETCH_AB_TEST_FLAVOR_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchABFlavor'));
};

const fetchAllAppFeatureFlags = () => async (dispatch, getState) => {
  const featureFlagsGrouped = studySelectors.getFeatureFlagsGrouped(getState());
  if (featureFlagsGrouped) {
    return featureFlagsGrouped;
  }
  dispatch({ type: studentStudyActionType.REQUEST_START });
  try {
    const response = await Promise.all([
      fetchGroupedFeatureFlags(Application.EAQ),
      fetchGroupedFeatureFlags(Application.STUDENT_STUDY)
    ]);
    const allFlagsResponse = response.flat();
    dispatch({
      payload: allFlagsResponse,
      type: studentStudyActionType.FETCH_GROUPED_FEATURE_FLAGS_SUCCESS
    });
    const courseSectionId = studySelectors.getCourseSectionId(getState());
    const promises = [];
    const activeABTests = getActiveABTestFlags(allFlagsResponse, courseSectionId);
    if (activeABTests && activeABTests.length) {
      activeABTests.forEach((activeABTest) => {
        promises.push(fetchABFlavor(activeABTest)(dispatch, getState));
      });
    }
    if (promises.length) {
      return Promise.all(promises)
        .then(() => {
          return allFlagsResponse;
        });
    }
    return allFlagsResponse;
  } catch (e) {
    return handleRequestError(dispatch, getState)(e, 'fetchAllAppFeatureFlags');
  }
};

const fetchTaxonomy = (taxonomyId: string) => (dispatch, getState): Promise<RecTaxonomyNodeDto[]> => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchTaxonomyService(taxonomyId)
    .then((data) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return data;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchTaxonomy'));
};

const openVitalSource = (
  isbn: string,
  page: number
) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchVitalSource({
    isbn,
    page,
  })
    .then(vitalSource => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      const openedWindow = window.open(vitalSource.signInUrl, '_blank');
      if (openedWindow) {
        openedWindow.opener = null;
      }
      return openedWindow;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'openVitalSource'));
};

const fetchGroupActivity = (vtwId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchResourceInfo(vtwId)
    .then(response => {
      dispatch({
        payload: response as GroupActivityDto,
        type: studentStudyActionType.FETCH_GROUP_ACTIVITY_SUCCESS
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchGroupActivity'));
};

const fetchAssessmentSubmissions = (
  assignmentId: string,
  isTrackRequestCount = true
) => (dispatch, getState): Promise<AssessmentSubmissionDto[]> => {
  if (isTrackRequestCount) {
    dispatch({ type: studentStudyActionType.REQUEST_START });
  }
  return fetchAssessmentSubmissionsService(assignmentId)
    .then((assessmentSubmissions) => {
      const payload = { assignmentId, assessmentSubmissions, isTrackRequestCount };
      dispatch({ payload, type: studentStudyActionType.FETCH_ASSESSMENT_SUBMISSIONS_SUCCESS });
      return assessmentSubmissions;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssessmentSubmissions', isTrackRequestCount));
};

const fetchAllAssessmentSubmissionsAction = (
  assignmentIds: string[],
  isTrackRequestCount = true
) => (dispatch, getState): Promise<Record<string, AssessmentSubmissionDto[]>> => {
  if (isTrackRequestCount) {
    dispatch({ type: studentStudyActionType.REQUEST_START });
  }
  return Promise.all(
    assignmentIds.map((assignmentId) => {
      return fetchAssessmentSubmissionsService(assignmentId)
        .then((assessmentSubmissions) => {
          return {
            assignmentId,
            assessmentSubmissions
          };
        });
    })
  )
    .then((assessmentSubmissionsResponses) => {
      const payload = {
        assessmentSubmissionsMap: getAssessmentSubmissionsMap(assessmentSubmissionsResponses),
        isTrackRequestCount
      };
      dispatch({ payload, type: studentStudyActionType.FETCH_ALL_ASSESSMENT_SUBMISSIONS_SUCCESS });
      return payload.assessmentSubmissionsMap;
    })
    .catch((e) => {
      return handleRequestError(dispatch, getState)(e, 'fetchAllAssessmentSubmissionsAction', isTrackRequestCount);
    });
};

const fetchAssignments = (
  courseSectionId: string,
) => (dispatch, getState): Promise<AssignmentDto[]> => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssignmentsService(courseSectionId)
    .then((assignments) => {
      const payload = { assignments };
      dispatch({ payload, type: studentStudyActionType.FETCH_ASSIGNMENTS_SUCCESS });
      return Promise.resolve(assignments);
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssignments'));
};

const fetchEolsUser = (userId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchUserService(userId)
    .then((data) => {
      dispatch({ payload: data, type: studentStudyActionType.FETCH_EOLS_USER_SUCCESS });
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchEolsUser'));
};

const fetchEvolveUsers = (userId: string, useCache = false) => (dispatch, getState) => {
  if (useCache) {
    const evolveUser = studySelectors.getEvolveUser(getState());
    if (evolveUser) {
      return Promise.resolve(evolveUser);
    }
  }
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchCrosswalkUserService(userId, SystemType.EVOLVETYPE)
    .then((crosswalkUser) => {
      dispatch({ payload: crosswalkUser, type: studentStudyActionType.FETCH_EVOLVE_USER_SUCCESS });
      return crosswalkUser;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchEvolveUsers'));
};

const fetchCrosswalkUsers = (userId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchCrosswalkUserService(userId, SystemType.EVOLVETYPE)
    .then((crosswalkUser) => {
      return Promise.all(crosswalkUser.eolsUserIdsByUserNameAndType.map(eolsUserIdByUserNameAndType => {
        return fetchUserService(eolsUserIdByUserNameAndType.toString());
      }));
    })
    .then(users => dispatch({ payload: users, type: studentStudyActionType.FETCH_CROSSWALK_USERS_SUCCESS }))
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchCrosswalkUsers'));
};

const putAssignments = (assignments: AssignmentDto[]) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  const requests = assignments.map(assignment => putAssignmentService(assignment));
  return Promise.all(requests)
    .then(() => {
      const assignmentsDictionary = keyBy(assignments, 'id');
      dispatch({ payload: assignmentsDictionary, type: studentStudyActionType.PUT_ASSIGNMENTS_SUCCESS });
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'putAssignments'));
};

const updateCollapsedFolderIds = (props: string[], userId: string, courseSectionId: string) => (dispatch, getState) => {
  dispatch({ payload: props, type: studentStudyActionType.UPDATE_COLLAPSED_FOLDER_IDS });

  const eolsUserHistoryDTO = {
    eolsUser: {
      id: parseInt(userId, 10)
    },
    stateKey: CoursewareUserHistoryStateKey.COLLAPSED_FOLDERS,
    courseSectionId: parseInt(courseSectionId, 10),
    stateInfo: JSON.stringify(props)
  };

  return fetchUserHistoryByCourseByStateKeyService({
    userId: eolsUserHistoryDTO.eolsUser.id,
    stateKey: eolsUserHistoryDTO.stateKey,
    courseSectionId: eolsUserHistoryDTO.courseSectionId
  })
    .then((response: EolsUserHistoryResponseDto[]) => {
      return response.sort((a, b) => {
        return a.id - b.id;
      }).find((userHistory) => {
        return userHistory.stateKey === eolsUserHistoryDTO.stateKey;
      });
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        return {} as EolsUserHistoryResponseDto;
      }
      return Promise.reject(error);
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchUserHistoryByCourseByStateKeyService', false))
    .catch(() => {
      return {} as EolsUserHistoryResponseDto;
    })
    .then((userHistory) => {
      return postUserHistoryService({
        ...userHistory,
        ...eolsUserHistoryDTO
      });
    });
};

const setStoreProps = (props: Partial<StudentStudyStore>) => (dispatch) => {
  dispatch({ payload: props, type: studentStudyActionType.SET_STORE_PROPS });
};

const setEnableDeepLink = (enableDeepLink: boolean) => (dispatch) => {
  dispatch({ payload: enableDeepLink, type: studentStudyActionType.SET_ENABLE_DEEP_LINK });
};

const fetchUserEngagementReport = (courseSectionId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });

  return fetchUserEngagementReportService(courseSectionId)
    .then((response: EolsUserEngagementDto[]) => {
      dispatch({
        payload: response,
        type: studentStudyActionType.FETCH_USER_ENGAGEMENT_REPORT_SUCCESS,
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchUserEngagementReport'));
};

const fetchHashLinkAction = (hashLink: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchHashLink(hashLink)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchHashLinkAction'));
};

const fetchDeepLinkDataAction = (deepLinkGuid: string, courseSectionId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchDeepLinkData(deepLinkGuid, courseSectionId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchDeepLinkDataAction'));
};

const postDeepLinkAction = (data: DeepLinkPostDto) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return postDeepLink(data)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'postDeepLinkAction'));
};

const fetchAssignmentAction = (assignmentId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssignment(assignmentId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssignmentAction'));
};

const fetchUserCourseSectionsAction = (userId: string, active = true, entitled?: boolean) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchUserCourseSections(userId, active, entitled)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchUserCourseSectionsAction'));
};

const fetchAnalyticsContextAction = (analyticsRequestDto: LearningAnalyticsRequestDto) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAnalyticsContext(analyticsRequestDto)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAnalyticsContextAction'))
    .catch(() => null);
};

const fetchLessonTopicsAction = (lessonId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchLessonTopics(lessonId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchLessonTopicsAction'));
};

const fetchAssessmentSubmissionsAction = (assignmentId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssessmentSubmissionsService(assignmentId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssessmentSubmissionsAction'));
};

const fetchAssignmentResultsAction = (assignmentId: number) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssignmentResults(assignmentId)
    .then((response) => {
      dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssignmentResultsAction'));
};

const fetchStudentStudyAssessmentsAction = (courseSectionId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return fetchStudentStudyAssessments(courseSectionId)
    .then(response => {
      dispatch({
        type: studentStudyActionType.FETCH_STUDENT_STUDY_ASSESSMENTS_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchStudentStudyAssessmentsAction'));

};

const fetchStudentPerformanceDetailsAction = (assessmentId: number) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START, });
  return getStudentPerformanceDetails(assessmentId)
    .then(response => {
      dispatch({
        type: studentStudyActionType.FETCH_STUDENT_PERFORMANCE_DETAILS_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchStudentPerformanceDetailsAction'));
};

const setRegisteredToken = (props: string) => (dispatch) => {
  dispatch({ payload: props, type: studentStudyActionType.SET_REGISTERED_TOKEN });
};

const fetchOsmosisTokenAction = () => (dispatch, getState) => {

  const token = studySelectors.getOsmosisToken(getState());
  if (!shouldGetNewOsmosisToken(token)) {
    return Promise.resolve(token);
  }

  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchOsmosisToken()
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_OSMOSIS_TOKEN_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchOsmosisTokenAction'));
};

const fetchOsmosisTranscriptAction = (learnName: string, auth: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchOsmosisTranscript(learnName, auth)
    .then((response) => {
      const scriptLink = get(response, 'data.learnData.scriptLink');
      if (!scriptLink) {
        return Promise.reject(new Error('Missing scriptLink'));
      }
      return axios.get(scriptLink).then((_response: AxiosResponse<string>) => {
        dispatch({ type: studentStudyActionType.REQUEST_SUCCESS });
        return {
          transcriptData: response.data,
          transcript: _response.data
        };
      });
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchOsmosisTranscriptAction'));
};

const fetchAllUserCourseSectionsAction = () => (dispatch, getState) => {

  const allUserCourseSections = studySelectors.getAllUserCourseSections(getState());

  if (allUserCourseSections) {
    return Promise.resolve(allUserCourseSections);
  }

  dispatch({ type: studentStudyActionType.REQUEST_START });
  const userId = studySelectors.getUserId(getState());

  return fetchEvolveUsers(userId)(dispatch, getState)
    .then((crossWalkUser) => {
      return Promise.all(
        crossWalkUser.eolsUserIdsByUserNameAndType.map((_userId) => {
          return fetchUserCourseSectionsAction(_userId.toString())(dispatch, getState);
        })
      );
    })
    .then((responses) => {
      return responses.reduce((acc, courseSections) => {
        return [
          ...acc,
          ...courseSections
        ];
      }, []);
    })
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_ALL_USER_COURSE_SECTIONS_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAllUserCourseSectionsAction'));
};

const postAssessmentAction = (userId: string, assessment: Partial<AssessmentDto>) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return postAssessment(userId, assessment)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((response) => {
      dispatch({
        type: studentStudyActionType.REQUEST_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'postAssessmentAction'));
};

const fetchAssessmentByIdAction = (userId: string, assessmentId: number) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchAssessmentById(userId, assessmentId)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((response) => {
      dispatch({
        type: studentStudyActionType.REQUEST_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAssessmentById'));
};

const fetchPrimaryTaxonomyAction = (isbn: string) => (dispatch, getState) => {
  const allPrimaryTaxonomies = studySelectors.getPrimaryTaxonomies(getState());

  if (allPrimaryTaxonomies && (allPrimaryTaxonomies[isbn] || allPrimaryTaxonomies[isbn] === null)) {
    return Promise.resolve(allPrimaryTaxonomies[isbn]);
  }

  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchPrimaryTaxonomy(isbn)
    .then((response) => {
      dispatch({
        type: studentStudyActionType.FETCH_PRIMARY_TAXONOMY_SUCCESS,
        payload: { isbn, response }
      });
      return response;
    })
    .catch((e) => {
      if (e.response && e.response.status === 404) {
        dispatch({
          type: studentStudyActionType.FETCH_PRIMARY_TAXONOMY_SUCCESS,
          payload: { isbn, response: null }
        });
        return null;
      }
      return Promise.reject(e);
    })
    .catch((error) => {
      return handleRequestError(dispatch, getState)(error, 'fetchPrimaryTaxonomyAction');
    });

};
const fetchCaseStudyAction = (caseStudyVtwId: string) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchCaseStudy(caseStudyVtwId)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((response) => {
      dispatch({
        type: studentStudyActionType.REQUEST_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchCaseStudyAction'));
};

const fetchEolsAssessmentSubmissionsAction = (assessmentIds: number[]) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return fetchEolsAssessmentSubmissions(assessmentIds)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((response) => {
      dispatch({
        type: studentStudyActionType.REQUEST_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchEolsAssessmentSubmissionsAction'));
};

const postSubmissionAction = (submission: Partial<AssessmentSubmissionDto>) => (dispatch, getState) => {
  dispatch({ type: studentStudyActionType.REQUEST_START });
  return postSubmission(submission)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((response) => {
      dispatch({
        type: studentStudyActionType.REQUEST_SUCCESS,
        payload: response
      });
      return response;
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'postSubmissionAction'));
};

const setEcrIdAction = (ecrId: string) => (dispatch) => {
  dispatch({ payload: ecrId, type: studentStudyActionType.SET_ECRID });
};

const setQuestionCountByTopicAction = (topicQuestionCount: TopicQuestionCountDto[]) => (dispatch) => {
  dispatch({ payload: topicQuestionCount, type: studentStudyActionType.SET_QUESTION_COUNT_BY_TOPIC_ACTION });
};

const fetchAvailableNumberOfQuestionsAction = (eaqRecommenderQuestions:
   { isbnTopicMap: EaqRecommenderQuestionsDto['isbnTopicMap'];
     courseISBNS: EaqRecommenderQuestionsDto['courseISBNS'];
     size: EaqRecommenderQuestionsDto['size'];
     questionCount: EaqRecommenderQuestionsDto['questionCount'];
   }, selectedQuestionSetIsbn: string) => (dispatch, getState) => {
  const questionCountByTopic = studySelectors.getQuestionCountByTopic(getState());
  const selectedTopicsArr = eaqRecommenderQuestions.isbnTopicMap[selectedQuestionSetIsbn];

  // * - Grab the selected topics that have been previously selected
  const topicsInStore = questionCountByTopic.filter(topicCount => {
    return selectedTopicsArr.find((selectedTopic) => selectedTopic === topicCount.topic);
  });
  const totalStoredQuestionCount = topicsInStore.reduce((total, current) => total + current.questionCount, 0);

  dispatch({ type: studentStudyActionType.REQUEST_START });

  // * - If all selected topics have been previously fetched, just use the total count
  // * - Also, handles when topics are unselected since remaining have been previously fetched
  if (topicsInStore.length === selectedTopicsArr.length) {
    dispatch({
      type: studentStudyActionType.FETCH_AVAILABLE_NUMBER_OF_QUESTIONS_SUCCESS,
      payload: totalStoredQuestionCount
    });

    return totalStoredQuestionCount;
  }

  // * - If at least 1 selected topic has NOT been previously fetched, fetch total count and store new topic
  return fetchNumberOfQuestions(eaqRecommenderQuestions)
    // eslint-disable-next-line sonarjs/no-identical-functions
    .then((maxNumber) => {
      dispatch({
        type: studentStudyActionType.FETCH_AVAILABLE_NUMBER_OF_QUESTIONS_SUCCESS,
        payload: maxNumber
      });
      const lastSelectedTopic = [...selectedTopicsArr].pop();

      if (questionCountByTopic.length === 0) {
        questionCountByTopic.push({ topic: lastSelectedTopic, questionCount: maxNumber });
      } else {
        const lastSelectedTopicCount = maxNumber - totalStoredQuestionCount;
        questionCountByTopic.push({ topic: lastSelectedTopic, questionCount: lastSelectedTopicCount });
      }

      dispatch(setQuestionCountByTopicAction(questionCountByTopic));

      return maxNumber;
    }).catch((e) => {
      if (e.response && e.response.status === 404) {
        dispatch({
          type: studentStudyActionType.FETCH_AVAILABLE_NUMBER_OF_QUESTIONS_SUCCESS,
          payload: null
        });
        return null;
      }
      return Promise.reject(e);
    })
    .catch((e) => handleRequestError(dispatch, getState)(e, 'fetchAvailableNumberOfQuestionsAction'));
};

export const studyActions = {
  deleteUserHistoryByUserId: deleteUserHistoryWithUserId,
  fetchAppLinkData,
  fetchRecentAssessmentOfAssignment,
  fetchAssignments,
  fetchCourseSection,
  fetchIsbns: fetchIsbnsAction,
  fetchCrosswalkUsers,
  fetchEolsUser,
  fetchEvolveUsers,
  fetchTaxonomy,
  fetchUserCourseOwnerRecords,
  fetchUsers,
  fetchUserHistoryByCourseByStateKey,
  fetchStudentStudyAssessmentsAction,
  fetchStudentPerformanceDetailsAction,
  navigateToApp,
  openVitalSource,
  postUserHistory,
  putAssignments,
  resetState,
  resetStateOnLaunch,
  restoreState,
  setIsbns,
  setIsCourseOwner,
  setMessages,
  setStoreProps,
  setUser,
  updateCourseSection,
  fetchAllAppFeatureFlags,
  setAppLinkCookies,
  returnAppLink,
  updateCollapsedFolderIds,
  trackAction,
  fetchUserEngagementReport,
  fetchGroupActivity,
  trackAdobeAction,
  setEnableDeepLink,
  fetchHashLinkAction,
  fetchDeepLinkDataAction,
  postDeepLinkAction,
  fetchAssignmentAction,
  fetchUserCourseSectionsAction,
  fetchAnalyticsContextAction,
  fetchLessonTopicsAction,
  fetchAssessmentSubmissionsAction,
  fetchAssignmentResultsAction,
  getExternalAppRedirectUrlAction,
  fetchAssessmentsByAssignmentIdAndUserIdAction,
  fetchAllAssessmentSubmissionsAction,
  setRegisteredToken,
  fetchOsmosisTokenAction,
  fetchOsmosisTranscriptAction,
  fetchAllUserCourseSectionsAction,
  fetchAssessmentByIdAction,
  fetchPrimaryTaxonomyAction,
  postAssessmentAction,
  fetchCaseStudyAction,
  fetchEolsAssessmentSubmissionsAction,
  fetchAssessmentSubmissions,
  postSubmissionAction,
  setEcrIdAction,
  fetchAvailableNumberOfQuestionsAction,
  setQuestionCountByTopicAction
};
